// Module
var code = `<div> Loading... </div> `;
// Exports
module.exports = code;